import gql from 'graphql-tag'

import { Mutation } from '../../types-graphql'

export type TDataDownloadExternalCourseUsersMonitoring = Pick<
  Mutation,
  'downloadExternalCourseUsersMonitoring'
>
export const DOWNLOAD_EXTERNAL_COURSE_USERS_MONITORING = gql`
  mutation ($input: DownloadExternalCourseUsersMonitoringInput!) {
    downloadExternalCourseUsersMonitoring(input: $input) {
      url
      hasNextPage
    }
  }
`
